import { API_URL } from "../../clients/feathers.clients";

export const PROTOCOL_HTTP = "http";
export const HOST_API = `${API_URL}/`;
export const PATH_S3_BUCKET = "https://sushi2go-static.s3.amazonaws.com";
export const DEFAULT_AVATAR_IMAGE = "../../../public/avatar.png";

export const BUCKET = "sushi2go-static";
